export const LOGIN = 'LOGIN'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGOUT = 'LOGOUT'
export const LOGIN_DISABLED = 'LOGIN_DISABLED'


// WEBPACK FOOTER //
// ./src/store/modules/login/mutation-types.js